<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        操作日志
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dateRange">
            <el-date-picker
              v-model="slotForms.forms.dateRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <e6Select
              :dataList="userList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="userTreeSelect"
              :placeholder="'选择用户'"
            ></e6Select>
          </el-form-item>
          <el-form-item>
            <e6Select
              :dataList="moduleList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="moduleTreeSelect"
              :placeholder="'选择模块'"
            ></e6Select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          :show-overflow-tooltip="true"
          label="用户"
          width="160"
          header-align="center"
          align="left"
          prop="operateUserName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="operateTime"
          label="操作时间"
          min-width="160"
          header-align="center"
          align="left"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="operateModuleStr"
          label="功能模块"
          min-width="120"
          header-align="center"
          align="left"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="ipAddress"
          label="IP"
          min-width="150"
          header-align="center"
          align="left"
        >
        </el-table-column>
        <el-table-column
          prop="operateContent"
          label="操作内容"
          min-width="150"
          header-align="center"
          align="left"
        >
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  FetchByPage,
  FetchModuleTree,
  FetchUserTree
} from "@/api/systemSetting/operateLogManage";
import { mapActions, mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      userList: [],
      moduleList: [],
      pickerOptions: datePickerOptionsNotContainToday,
      formExtend: {
        forms: {
          dateRange: [
            moment().format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          comparyName: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      loading: "false",
      //导出URL
      exportUrl: "/base/operateLogManage/exportOperateLog?",
      datePickerOptions: datePickerOptionsNotContainToday
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    //初始化模块列表
    this.initModuleTree();
    //初始化用户列表
    this.initUserTree();
  },
  mounted() {
    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.formExtend.forms.dateRange[0]);
      let end = moment(this.formExtend.forms.dateRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    //获取模块树数据
    initModuleTree() {
      FetchModuleTree()
        .then(response => {
          if (response.code == 1) {
            this.moduleList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取用户树数据
    initUserTree() {
      FetchUserTree()
        .then(response => {
          if (response.code == 1) {
            this.userList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      if (this.validataTime()) {
        this.loading = true;
        response.operateTimeParamStart = moment(response.dateRange[0])
          .startOf("day")
          .valueOf();
        response.operateTimeParamEnd = moment(response.dateRange[1])
          .endOf("day")
          .valueOf();
        FetchByPage(response)
          .then(response => {
            if (
              response.result &&
              response.result.data &&
              Array.isArray(response.result.data)
            ) {
              this.tableData = response.result.data;
              this.total = response.result.totalRecords;
            }
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    // 整合查询数据
    mergeObj() {
      let userListParam = this.getUserListSelect();
      let moduleListParam = this.getModuleListSelect();
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        userIdListParam: userListParam,
        moduleIdListParam: moduleListParam,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    //获取选择的用户
    getUserListSelect() {
      let selected = this.$refs.userTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    //获取选择的模块
    getModuleListSelect() {
      let selected = this.$refs.moduleTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    // 导出excel 表格
    handleExport() {
      let params = this.searchData;
      this.exportData(params);
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportListByComparyOnLine(params).then(res => {
          // 导出
          exportXlsx(res, `企业在线率排行.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.dateRange !== null &&
        this.formExtend.forms.dateRange !== ""
      ) {
        param +=
          "&operateTimeParamStart=" +
          moment(this.formExtend.forms.dateRange[0])
            .startOf("day")
            .valueOf();
        param +=
          "&operateTimeParamEnd=" +
          moment(this.formExtend.forms.dateRange[1])
            .endOf("day")
            .valueOf();
        //获取选择的用户
        let userListParam = this.getUserListSelect();
        if (userListParam != null && userListParam.length > 0) {
          param += "&userIdListParam=" + userListParam;
        }
        //获取选择的模块
        let moduleListParam = this.getModuleListSelect();
        if (moduleListParam != null && moduleListParam.length > 0) {
          param += "&moduleIdListParam=" + moduleListParam;
        }
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "日期不能为空！",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_fill {
    color: #fff !important;
  }
}
</style>
